export function commonMethod(text: string) {
    return text + '44';
}
